export default __webpack_public_path__ + "airspace.e716837b.svg";